export const CompaniesMeta = 'Company';
export const ProjectsMeta = 'Project';
export const ArchivesMeta = 'Archives';
export const OverviewMeta = 'Overview';
export const IntakesMeta = 'Intakes';
export const UsersMeta = 'Users';
export const ClientsMeta = 'Clients';